module.exports = __webpack_public_path__ + "img/knowledgebase.d02ac13b.jpg";